import { DamageIssueType, ItemCondition, ItemType, PackageType, PackageTypeCondition } from '../../../../enums';

export interface IProductDamageSubtypeDom {
    issueType: DamageIssueType;
    itemType: ItemType;
    conditionOfItem: ItemCondition[];
    documentationNotedIssue?: boolean;
    damageClaimFiled?: boolean;
    packageType?: PackageType;
    protectivePackagingUsed?: boolean;
    packageTypeCondition?: PackageTypeCondition;
    additionalPackagingInfo?: string;
}
